import { useSyncExternalStore } from 'react'

export const OGSM_SHOW_INACTIVE_KEY = 'compass.ogsm.showInactive'

const listeners = new Set<() => void>()
let memory = false
// After a write fails, storage would hand back the stale value, so memory wins.
let storageUsable = true

function getSnapshot(): boolean {
  if (!storageUsable) return memory
  try {
    memory = window.localStorage.getItem(OGSM_SHOW_INACTIVE_KEY) === 'true'
  } catch {
    // Blocked storage (private mode, policy): keep the in-memory value.
  }
  return memory
}

const getServerSnapshot = () => false

function subscribe(onChange: () => void) {
  listeners.add(onChange)
  const onStorage = (event: StorageEvent) => {
    if (event.key === OGSM_SHOW_INACTIVE_KEY || event.key === null) onChange()
  }
  window.addEventListener('storage', onStorage)
  return () => {
    listeners.delete(onChange)
    window.removeEventListener('storage', onStorage)
  }
}

function setShowInactive(next: boolean) {
  memory = next
  try {
    if (next) window.localStorage.setItem(OGSM_SHOW_INACTIVE_KEY, 'true')
    else window.localStorage.removeItem(OGSM_SHOW_INACTIVE_KEY)
  } catch {
    storageUsable = false
  }
  listeners.forEach((listener) => listener())
}

const toggleShowInactive = () => setShowInactive(!getSnapshot())

/** Whether the OGSM board shows inactive strategies; one value per browser, hidden by default. */
export function useOgsmShowInactive(): {
  showInactive: boolean
  toggleShowInactive: () => void
} {
  const showInactive = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )
  return { showInactive, toggleShowInactive }
}
